// eslint-disable-next-line
import { queryFilterDashboard } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const dashboardInFlightRequests = new Map<string, Promise<any>>();
const dashboardResponseCache = new Map<string, { data: any; expiresAt: number }>();
const dashboardResponseCacheTtlMs = 30 * 1000;

const normalizeDashboardRequestKey = (method: string, rawUrl: string) => {
  const [path, queryString = ''] = rawUrl.split('?');
  const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
  const searchParams = new URLSearchParams(queryString);
  const pairs: Array<[string, string]> = [];
  searchParams.forEach((value, key) => {
    const normalizedValue = `${value ?? ''}`.trim();
    if (
      normalizedValue === '' ||
      normalizedValue.toLowerCase() === 'null' ||
      normalizedValue.toLowerCase() === 'undefined'
    ) {
      return;
    }
    pairs.push([key, normalizedValue]);
  });
  pairs.sort(([aKey, aValue], [bKey, bValue]) => {
    if (aKey === bKey) return aValue.localeCompare(bValue);
    return aKey.localeCompare(bKey);
  });
  const normalizedQuery = new URLSearchParams(pairs).toString();
  return `${method}:${normalizedPath}${normalizedQuery ? `?${normalizedQuery}` : ''}`;
};

const executeDashboardGetDeduped = (url: string) => {
  const requestKey = normalizeDashboardRequestKey(methods.GET, url);
  const cached = dashboardResponseCache.get(requestKey);
  if (cached && cached.expiresAt > Date.now()) {
    return Promise.resolve(cached.data);
  }
  if (cached && cached.expiresAt <= Date.now()) {
    dashboardResponseCache.delete(requestKey);
  }
  const existing = dashboardInFlightRequests.get(requestKey);
  if (existing) {
    return existing;
  }

  const request = execute(methods.GET, url, { authorization: true })
    .then((response) => {
      dashboardResponseCache.set(requestKey, {
        data: response,
        expiresAt: Date.now() + dashboardResponseCacheTtlMs,
      });
      return response;
    })
    .finally(() => {
      dashboardInFlightRequests.delete(requestKey);
    });

  dashboardInFlightRequests.set(requestKey, request);
  return request;
};

const getItemSaleFilter = (queryFilter: queryFilterDashboard) => {
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/item-sale/?${params.toString()}`;
    return executeDashboardGetDeduped(url);
  };
const getLowHighStockFilter = (queryFilter: queryFilterDashboard) => {
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.dashboard.dashboard}/low-high-stock/?${params.toString()}`;
  return executeDashboardGetDeduped(url);
};
const getItemShrinkageFilter = (queryFilter: queryFilterDashboard) => {
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/shrinkage/locations/?${params.toString()}`;
    return executeDashboardGetDeduped(url);
  };
const getItemShrinkageByLocation = (orgId: string, locationId: string) => {
    const url = `${urls.dashboard.dashboard}/shrinkage/organization/${orgId}/location/${locationId}/categories`;
    return executeDashboardGetDeduped(url);
  };
const getItemShrinkageByCategory = (locationId: string, categoryId: string) => {
    const url = `${urls.dashboard.dashboard}/shrinkage/location/${locationId}/category/${categoryId}/items`;
    return executeDashboardGetDeduped(url);
  };
const getItemInventoryFilter = (queryFilter: queryFilterDashboard) => {
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/inventory/?${params.toString()}`;
    return executeDashboardGetDeduped(url);
  };

export {
    getItemSaleFilter,
    getLowHighStockFilter,
    getItemShrinkageFilter,
    getItemInventoryFilter,
    getItemShrinkageByLocation,
    getItemShrinkageByCategory
};
